// removed by extract-text-webpack-plugin
module.exports = {"srOnly":"srOnly","funeral-home-profile":"funeral-home-profile","react-tabs":"react-tabs","react-tabs__tab-list":"react-tabs__tab-list","tab-header":"tab-header","react-tabs__tab--selected":"react-tabs__tab--selected","react-tabs__tab":"react-tabs__tab","react-tabs__tab--disabled":"react-tabs__tab--disabled","react-tabs__tabfocus":"react-tabs__tabfocus","react-tabs__tabfocusafter":"react-tabs__tabfocusafter","react-tabs__tab-panel":"react-tabs__tab-panel","react-tabs__tab-panel--selected":"react-tabs__tab-panel--selected"};


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Profile/components/Tabs/css/Tabs.styl
// module id = 1550
// module chunks = 0